import { render, staticRenderFns } from "./book-simple.vue?vue&type=template&id=366b0587&scoped=true"
import script from "./book-simple.vue?vue&type=script&lang=js"
export * from "./book-simple.vue?vue&type=script&lang=js"
import style0 from "./book-simple.vue?vue&type=style&index=0&id=366b0587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b0587",
  null
  
)

export default component.exports